import ExpensesContainer from "./ExpensesContainer";

export default ExpensesContainer;
